import { render, staticRenderFns } from "./PackageUpgrade.vue?vue&type=template&id=fb74a8a6&"
import script from "./PackageUpgrade.vue?vue&type=script&lang=js&"
export * from "./PackageUpgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports